import { Injectable } from '@angular/core';

@Injectable()
export class ClienteModel {
    clienteContratoId: number;
    codigo: string;
    nomeTitular: string;
    rg: string;
    cpf: string;
    email: string;
    foneResidencia: string;
    celular: string;
    logo: [any];
    nomeLogo: string;

    constructor() {
    }
}

export class ClienteResult {
  public sucesso: boolean;
  public erros: Array<any>;
  public warnings: Array<any>;
  public cliente: ClienteModel;
}
